var lib_core = require("lib-core");

var ModelUploadStateMachine = require("./modelUploadStateMachine");
var UploadController = require("ui-extensions").UploadController;
var Editor3d = require("editor-3d-light").Editor3dController;
var TabController = require("ui-extensions").TabController;
var ProcessMessageController = require("ui-extensions").ProcessMessageController;
var ErrorMessageController  = require("ui-extensions").ErrorMessageController;
var PackageViewerController  = require("./../footprint3dViewer/packageFootprintViewerController.js");
var ModelUploadView = require("./modelUploadView.js");
var PackageMasterController = require("../packageMasterView/packageMasterController.js");

var ModelUploadController = function(archLayers, dependencies, configuration) {
     UploadController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(ModelUploadController, UploadController);
ModelUploadController.inject = {
    tabController            : TabController,
    processMessageController : ProcessMessageController,
    errorController          : ErrorMessageController,
    editor3d                 : Editor3d,
    packageController        : PackageViewerController,
    masterController         : PackageMasterController
};

module.exports = ModelUploadController;


ModelUploadController.prototype.createStateMachine = function () {
    var editor3dModel = this.editor3d.getModel();

    return new ModelUploadStateMachine(this.root, this.processMessageController.getModel(), this.root.dataLoader.dataManager, this.packageController.getModel(), this.configuration);
};

ModelUploadController.prototype.createView = function () {
    return new ModelUploadView(this.toggleButton, this.masterController.getView(), this.configuration);
};
 